import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '~/components/ui/button';
import { useThemeStore } from '~/lib/store/theme';

/** Single-click light/dark toggle. Shows the sun in dark mode, the moon in light mode. */
export function ThemeToggle() {
	const { t } = useTranslation();
	const theme = useThemeStore(s => s.theme);
	const toggle = useThemeStore(s => s.toggle);
	const isDark = theme === 'dark';
	return (
		<Button
			variant="ghost"
			size="icon-sm"
			onClick={toggle}
			aria-label={t(isDark ? 'shell.theme.toLight' : 'shell.theme.toDark')}
			title={t(isDark ? 'shell.theme.toLight' : 'shell.theme.toDark')}>
			{isDark ? <Sun size={16} /> : <Moon size={16} />}
		</Button>
	);
}
